import getSurveyQuestions from './SurveyQuestions';

// export default {
//     getSurveyQuestions,
// };

export default getSurveyQuestions;
